import Vue from 'vue';
import * as VueGoogleMaps from 'gmap-vue';
import GmapCluster from 'gmap-vue/dist/components/cluster';
Vue.component('GmapCluster', GmapCluster);

export function loadMapsPlugin(gmapsApiKey) {
	const load = !window?.google?.maps
		? {
				key: gmapsApiKey,
				libraries: 'places'
		  }
		: null;
	Vue.use(VueGoogleMaps, {
		load,
		installComponents: true
	});
	if (!load) {
		window.vueGoogleMapsInit();
	}
}
